require('./RAHireManagementPlanLegalConfirmation.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

//@core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');

// @ constants
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const { EVIDENCE_WEALTH_ROBO_HIRING } = require('constants/flagBasedFeatures');

class RAHireManagementPlanLegalConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.refreshEmailAddressHandler = this.refreshEmailAddressHandler.bind(
            this,
        );
        this.sendMailHandler = this.sendMailHandler.bind(this);
    }

    handleValueChange(value) {
        const onYesNoOptionChange = this.props.onYesNoOptionChange;

        onYesNoOptionChange && onYesNoOptionChange(value);
    }

    refreshEmailAddressHandler(byPassCache) {
        const { refreshEmailAddress, onYesNoOptionChange } = this.props;

        onYesNoOptionChange && onYesNoOptionChange(SELECTED_VALUES.EMPTY);
        refreshEmailAddress(byPassCache);
    }

    sendMailHandler(params) {
        const {
            sendMail,
            onYesNoOptionChange,
            immHireManagementPlan,
            flagBasedFeatures,
        } = this.props;
        const operationProcessId = immHireManagementPlan.get(
            'operationProcessId',
        );
        const paramsForEmail = {
            ...params,
            operationProcessId: operationProcessId,
            evidenceType: 'SIGN_DOCUMENT',
            implicitCosts: immHireManagementPlan.get('productCost'),
        };
        onYesNoOptionChange && onYesNoOptionChange(SELECTED_VALUES.EMPTY);
        flagBasedFeatures.get(EVIDENCE_WEALTH_ROBO_HIRING)
            ? sendMail(paramsForEmail)
            : sendMail(params);
    }

    buildDocumentsAvailability() {
        const { documentsAvailability } = this.props;

        let documentsAvailabilityBlock = null;

        if (documentsAvailability) {
            documentsAvailabilityBlock = (
                <BlockInfo extraClass="ra-hire-management-plan-legal-confirmation__block-info">
                    {documentsAvailability}
                </BlockInfo>
            );
        }

        return documentsAvailabilityBlock;
    }

    buildProductDescription() {
        const { productDescription } = this.props;

        let productDescriptionBlock = null;

        if (productDescription) {
            productDescriptionBlock = (
                <BlockInfo extraClass="ra-hire-management-plan-legal-confirmation__block-info">
                    {productDescription}
                </BlockInfo>
            );
        }

        return productDescriptionBlock;
    }

    buildYesNoQuestion() {
        const {
            legalQuestion,
            selectedYesNoOption,
            immPreContractualMail,
            refreshEmailAddressError,
        } = this.props;

        let yesNoQuestion = null;

        if (legalQuestion) {
            const optionsDisabled =
                !immPreContractualMail.get('mailSent') ||
                !!refreshEmailAddressError;

            yesNoQuestion = (
                <BlockInfo extraClass="ra-hire-management-plan-legal-confirmation__block-info">
                    {legalQuestion}
                    <RadioButtonGroup
                        className="ra-hire-management-plan-legal-confirmation__radio-group"
                        idPrefix="raHireManagementPlanLegalConfirmationYesNo"
                        name="raHireManagementPlanLegalConfirmationYesNo"
                        onChange={this.handleValueChange}
                        selectedValue={selectedYesNoOption}
                    >
                        <RadioButton
                            className="ra-hire-management-plan-legal-confirmation__radio"
                            disabled={optionsDisabled}
                            label={formatText(
                                'raHireManagementPlan-legalConfirmationYesValue',
                            )}
                            value={SELECTED_VALUES.YES}
                        />
                        <RadioButton
                            className="ra-hire-management-plan-legal-confirmation__radio"
                            disabled={optionsDisabled}
                            label={formatText(
                                'raHireManagementPlan-legalConfirmationNoValue',
                            )}
                            value={SELECTED_VALUES.NO}
                        />
                    </RadioButtonGroup>
                </BlockInfo>
            );
        }

        return yesNoQuestion;
    }

    buildAnswerOfYesNoQuestion() {
        const { selectedYesNoOption } = this.props;

        let answerOfYesNoQuestion = null;

        if (selectedYesNoOption === SELECTED_VALUES.YES) {
            answerOfYesNoQuestion = (
                <BlockInfo extraClass="ra-hire-management-plan-legal-confirmation__block-info">
                    <FormattedText value="raHireManagementPlan-legalConfirmationYesAnswer" />
                </BlockInfo>
            );
        } else if (selectedYesNoOption === SELECTED_VALUES.NO) {
            answerOfYesNoQuestion = (
                <BlockInfo extraClass="ra-hire-management-plan-legal-confirmation__block-info">
                    <p>
                        <FormattedText value="raHireManagementPlan-legalConfirmationNoAnswer1" />
                    </p>
                    <p>
                        <FormattedText value="raHireManagementPlan-legalConfirmationNoAnswer2" />
                    </p>
                </BlockInfo>
            );
        }

        return answerOfYesNoQuestion;
    }

    render() {
        const {
            className,
            clientEmailAddress,
            immPreContractualMail,
            refreshEmailAddressError,
        } = this.props;

        const documentsAvailability = this.buildDocumentsAvailability();
        const productDescription = this.buildProductDescription();
        const yesNoQuestion = this.buildYesNoQuestion();
        const answerOfYesNoQuestion = this.buildAnswerOfYesNoQuestion();
        const containerClassNames = classNames(
            'ra-hire-management-plan-legal-confirmation',
            className,
        );

        return (
            <div className={containerClassNames}>
                <div className="ra-hire-management-plan-legal-confirmation__header">
                    <i className="ra-hire-management-plan-legal-confirmation__header-icon icon-documento" />
                    <div className="ra-hire-management-plan-legal-confirmation__header-content">
                        <h3 className="ra-hire-management-plan-legal-confirmation__header-title">
                            <FormattedText value="raHireManagementPlan-legalConfirmationTitle" />
                        </h3>
                    </div>
                </div>
                <div className="ra-hire-management-plan-legal-confirmation__body">
                    {documentsAvailability}
                    <div className="ra-hire-management-plan-legal-confirmation__send-mail">
                        <PreContractualMailInfo
                            email={clientEmailAddress}
                            preContractualMail={immPreContractualMail}
                            profileError={refreshEmailAddressError}
                            requestProfile={this.refreshEmailAddressHandler}
                            sendEmail={this.sendMailHandler}
                            sendMailParams={{}}
                            showLegalText={false}
                        />
                    </div>
                    {productDescription}
                    {yesNoQuestion}
                    {answerOfYesNoQuestion}
                </div>
            </div>
        );
    }
}

RAHireManagementPlanLegalConfirmation.propTypes = {
    className: PropTypes.string,
    clientEmailAddress: PropTypes.string.isRequired,
    documentsAvailability: PropTypes.node,
    immPreContractualMail: PropTypes.object.isRequired,
    legalQuestion: PropTypes.node,
    onYesNoOptionChange: PropTypes.func,
    productDescription: PropTypes.node,
    refreshEmailAddress: PropTypes.func.isRequired,
    refreshEmailAddressError: PropTypes.string,
    selectedYesNoOption: PropTypes.string,
    sendMail: PropTypes.func.isRequired,
    immHireManagementPlan: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
};

module.exports = RAHireManagementPlanLegalConfirmation;
